import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Input from './input';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.bgContainer}>
                <div className={styles.headerContainer}>
                    <img
                        src="https://x0.ifengimg.com/ucms/2021_37/3E442EEA08DE847EDFB02B5317937610AF719995_size150_w1400_h499.png"
                        alt=""
                    />
                    <div className={styles.centerContainer}>
                        <img
                            src="https://x0.ifengimg.com/ucms/2021_36/8F6F869311DD3089F2639EBC0B32C86D7D5F03A2_size68_w612_h172.png"
                            alt=""
                        />
                        <Input content={content} />
                    </div>
                </div>
                <p>—— 版权所有：凤凰网本地化与政务事业部 ——</p>
                <img
                    className={styles.banYuan}
                    src="//x0.ifengimg.com/ucms/2021_37/49B7A5716ED3394035FE80C5DD403A79F8153066_size35_w421_h201.png"
                    alt=""
                />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
